/* APC email check for the storefront enquiry forms (product "Ask a question" tab,
   Contact page, cart-drawer out-of-area request).
   apcEmailCheck(value) -> { ok: bool, suggestion: string|null }
   - ok=false when the address can't possibly be delivered to (e.g. a surname typed
     into the email box - the 18 Oct 2026 "Crystal / Tintor" enquiry we couldn't answer).
   - suggestion is a corrected address when the domain looks like a typo of a common
     one (gmial.com, bigpond.con). The forms show it as a one-tap "Did you mean". */
(function () {
  if (window.apcEmailCheck) return;

  var DOMAINS = [
    'gmail.com', 'hotmail.com', 'hotmail.com.au', 'outlook.com', 'outlook.com.au',
    'live.com', 'live.com.au', 'yahoo.com', 'yahoo.com.au', 'icloud.com', 'me.com',
    'bigpond.com', 'bigpond.net.au', 'bigpond.com.au', 'optusnet.com.au', 'internode.on.net',
    'iinet.net.au', 'tpg.com.au', 'adam.com.au', 'westnet.com.au', 'msn.com', 'aol.com'
  ];
  var TLD_FIX = { con: 'com', cmo: 'com', ocm: 'com', vom: 'com', xom: 'com', comm: 'com', cm: 'com', om: 'com', 'co,': 'com' };

  function lev(a, b) {
    var m = a.length, n = b.length, prev = [], cur, i, j;
    for (j = 0; j <= n; j++) prev[j] = j;
    for (i = 1; i <= m; i++) {
      cur = [i];
      for (j = 1; j <= n; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1,
          prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
      }
      prev = cur;
    }
    return prev[n];
  }

  function suggestDomain(domain) {
    if (DOMAINS.indexOf(domain) !== -1) return null;
    // gmail.co / gmail.com.au -> gmail.com (gmail has no other TLDs)
    var m = domain.match(/^(gmail|hotmail|outlook|icloud)\.(co|cm|om|com\.au|co\.au|net)$/);
    if (m && m[1] === 'gmail') return 'gmail.com';
    if (m && m[1] === 'icloud') return 'icloud.com';
    var best = null, bestD = 99;
    for (var i = 0; i < DOMAINS.length; i++) {
      var d = lev(domain, DOMAINS[i]);
      if (d < bestD) { bestD = d; best = DOMAINS[i]; }
    }
    var allowed = domain.length <= 7 ? 1 : 2;
    if (best && bestD > 0 && bestD <= allowed) return best;
    // Unknown domain but obviously mistyped TLD: anything.con -> anything.com
    var parts = domain.split('.');
    var tld = parts[parts.length - 1];
    if (parts.length > 1 && TLD_FIX[tld]) {
      parts[parts.length - 1] = TLD_FIX[tld];
      return parts.join('.');
    }
    return null;
  }

  window.apcEmailCheck = function (value) {
    var email = String(value || '').trim().replace(/\s+/g, '');
    var ok = /^[^@\s]+@[^@\s.]+(\.[^@\s.]+)*\.[a-z]{2,}$/i.test(email) && email.indexOf('..') === -1;
    var suggestion = null;
    var at = email.lastIndexOf('@');
    if (at > 0) {
      var local = email.slice(0, at), domain = email.slice(at + 1).toLowerCase().replace(/[.,]+$/, '');
      var fixed = domain ? suggestDomain(domain) : null;
      if (fixed && fixed !== domain) suggestion = local + '@' + fixed;
    }
    return { ok: ok, suggestion: suggestion };
  };

  /* Shared UI for the two Liquid forms: validates on Send, offers "Did you mean". */
  window.apcEmailGuard = function (input) {
    if (!input) return function () { return true; };
    var hint = document.createElement('div');
    hint.className = 'apc-email-hint';
    hint.setAttribute('role', 'alert');
    hint.style.cssText = 'display:none;margin:-8px 0 12px;font-size:0.9em;color:#b3261e;';
    input.insertAdjacentElement('afterend', hint);
    var shownFor = null;

    function render(res, value, fromSubmit) {
      if (!res.ok && !res.suggestion) {
        hint.textContent = 'That doesn’t look like an email address — please check it so we can reply to you.';
      } else if (res.suggestion) {
        hint.innerHTML = '';
        hint.appendChild(document.createTextNode('Did you mean '));
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = res.suggestion;
        b.style.cssText = 'background:none;border:0;padding:0;color:inherit;text-decoration:underline;font:inherit;font-weight:600;cursor:pointer;';
        b.addEventListener('click', function () {
          input.value = res.suggestion;
          hint.style.display = 'none';
          input.removeAttribute('aria-invalid');
          shownFor = null;
        });
        hint.appendChild(b);
        hint.appendChild(document.createTextNode('?'));
      }
      hint.style.display = 'block';
      input.setAttribute('aria-invalid', 'true');
      if (fromSubmit) shownFor = value;
    }

    input.addEventListener('input', function () {
      hint.style.display = 'none';
      input.removeAttribute('aria-invalid');
    });
    input.addEventListener('blur', function () {
      var v = input.value.trim();
      if (!v) return;
      var res = window.apcEmailCheck(v);
      if (!res.ok || res.suggestion) render(res, v);
    });

    // Returns true when it's OK to send. An invalid address always blocks; a typo
    // suggestion blocks once, then lets them send what they typed (it may be right).
    return function () {
      var v = input.value.trim();
      var res = window.apcEmailCheck(v);
      if (!res.ok) { render(res, v, true); input.focus(); return false; }
      if (res.suggestion && shownFor !== v) { render(res, v, true); input.focus(); return false; }
      hint.style.display = 'none';
      input.removeAttribute('aria-invalid');
      return true;
    };
  };
})();
